import { Image, MessageSquare, Sliders } from "react-feather";
import {
  FaBars,
  FaBlogger,
  FaBoxes,
  FaCogs,
  FaHandsHelping,
  FaRegNewspaper,
  FaVideo,
  FaThList,
  FaRegCalendarAlt,
} from "react-icons/fa";
import { BiTable } from "react-icons/bi";
import { ImStatsBars } from "react-icons/im";
import { FcWorkflow, FcQuestions } from "react-icons/fc";
import { GiTatteredBanner } from "react-icons/gi";
import { FiMenu } from "react-icons/fi";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { HiOutlineTemplate } from "react-icons/hi";
import { RiQuestionnaireLine } from "react-icons/ri";
import { MdWidgets, MdQuiz } from "react-icons/md";
import { BsMoonStars, BsCurrencyExchange } from "react-icons/bs";

export default [
  {
    header: "Site Data",
  },
  {
    id: "view-topics-services",
    acl: "view-topics",
    title: "Services",
    icon: <FaCogs size={20} />,
    children: [
      {
        id: "services_list",
        acl: "view-topics",
        title: "Services",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/Services/topics",
      },
      {
        id: "services_categories",
        acl: "view-sections",
        title: "Services Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/Services/sections",
      },
      {
        id: "services_comments",
        acl: "view-topic-comments",
        title: "Services Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/Services/comment",
      },
    ],
  },
  {
    id: "view-topics-news",
    acl: "view-topics",
    title: "News",
    icon: <FaRegNewspaper size={20} />,
    children: [
      {
        id: "news_list",
        acl: "view-topics",
        title: "News List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/News/topics",
      },
      {
        id: "news_categories",
        acl: "view-sections",
        title: "News Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/News/sections",
      },
      {
        id: "news_comments",
        acl: "view-topic-comments",
        title: "News Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/News/comment",
      },
    ],
  },
  {
    id: "view-topics-blog",
    acl: "view-topics",
    title: "Blog",
    icon: <FaBlogger size={20} />,
    children: [
      {
        id: "blogs_list",
        acl: "view-topics",
        title: "Blogs List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/Blog/topics",
      },
      {
        id: "blogs_categories",
        acl: "view-sections",
        title: "Blogs Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/Blog/sections",
      },
      {
        id: "blogs_comments",
        acl: "view-topic-comments",
        title: "Blogs Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/Blog/comment",
      },
    ],
  },
  {
    id: "videos",
    acl: "videos",
    title: "Videos",
    icon: <FaVideo size={12} />,
    children: [
      {
        id: "view-videos",
        acl: "view-videos",
        title: "Videos List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/videos",
      },

      {
        id: "view-videos-comments",
        acl: "view-videos-comments",
        title: "Videos Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/video/comments",
      },
    ],
  },
  {
    id: "view-topics-pictures",
    acl: "view-topics",
    title: "Pictures",
    icon: <Image size={20} />,
    children: [
      {
        id: "pictures_list",
        acl: "view-topics",
        title: "Photos List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/Photos/topics",
      },
      {
        id: "pictures_categories",
        acl: "view-sections",
        title: "Photos Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/Photos/sections",
      },
      {
        id: "pictures_comments",
        acl: "view-topic-comments",
        title: "Photos Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/Photos/comment",
      },
    ],
  },
  {
    id: "view-topics-products",
    acl: "view-topics",
    title: "Products",
    icon: <FaBoxes size={20} />,
    children: [
      {
        id: "products_list",
        acl: "view-topics",
        title: "Products List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/Products/topics",
      },
      {
        id: "products_categories",
        acl: "view-sections",
        title: "Products Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/Products/sections",
      },
      {
        id: "products_comments",
        acl: "view-topic-comments",
        title: "Products Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/Products/comment",
      },
    ],
  },
  {
    id: "view-topics-partners",
    acl: "view-topics",
    title: "Partners",
    icon: <FaHandsHelping size={20} />,
    children: [
      {
        id: "partners_list",
        acl: "view-topics",
        title: "Partners List",
        icon: <FaRegNewspaper size={20} />,
        navLink: "/admin/Partners/topics",
      },
      {
        id: "partners_categories",
        acl: "view-sections",
        title: "Partners Categories",
        icon: <FaBars size={20} />,
        navLink: "/admin/Partners/sections",
      },
      {
        id: "partners_comments",
        acl: "view-topic-comments",
        title: "Partners Comments",
        icon: <MessageSquare size={20} />,
        navLink: "/admin/list/Partners/comment",
      },
    ],
  },
  {
    id: "website_settings",
    acl: "website_settings",
    title: "Website Settings",
    icon: <Sliders size={20} />,
    children: [
      {
        id: "view-banners",
        acl: "view-banners",
        title: "Banners",
        icon: <GiTatteredBanner size={20} />,
        navLink: "/admin/WebsiteSettings/banners",
      },
      {
        id: "menus",
        acl: "menus",
        title: "Menus",
        icon: <FiMenu size={20} />,
        children: [
          {
            id: "view-menus-list",
            acl: "view-menus-list",
            title: "Menus List",
            icon: <FiMenu size={20} />,
            navLink: "/admin/WebsiteSettings/menus/list",
          },
          {
            id: "view-menus-drag",
            acl: "view-menus-drag",
            title: "Menus Drag",
            icon: <FiMenu size={20} />,
            navLink: "/admin/WebsiteSettings/menus/menus_drag",
          },
        ],
      },
      {
        id: "view-contact",
        acl: "view-contact",
        title: "Contact",
        icon: <FiMenu size={20} />,
        navLink: "/admin/WebsiteSettings/contact",
      },
      {
        id: "view-personnalisation",
        acl: "view-personnalisation",
        title: "Personnalisation",
        icon: <FiMenu size={20} />,
        navLink: "/admin/WebsiteSettings/personnalisation",
      },
      // {
      //   id: "Widgets",
      //   acl: "Widgets",
      //   title: "Widgets",
      //   icon: <MdWidgets size={20} />,
      //   children: [
      //     {
      //       id: "view-widgets-list",
      //       acl: "view-widgets-list",
      //       title: "Widgets List",
      //       icon: <FaThList size={20} />,
      //       navLink: "/admin/WebsiteSettings/widgets/List",
      //     },
      //     {
      //       id: "view-weather",
      //       acl: "view-weather",
      //       title: "Weather",
      //       icon: <TiWeatherPartlySunny size={50} />,
      //       navLink: "/admin/WebsiteSettings/widgets/Weather",
      //     },
      //     {
      //       id: "view-holidays",
      //       acl: "view-holidays",
      //       title: "Holidays",
      //       icon: <FaRegCalendarAlt size={20} />,
      //       navLink: "/admin/WebsiteSettings/widgets/holydays",
      //     },
      //     {
      //       id: "view-horoscop",
      //       acl: "view-horoscop",
      //       title: "Horoscop",
      //       icon: <BsMoonStars size={20} />,
      //       navLink: "/admin/WebsiteSettings/widgets/horoscop",
      //     },
      //     {
      //       id: "view-currency",
      //       acl: "view-currency",
      //       title: "Currency",
      //       icon: <BsCurrencyExchange size={20} />,
      //       navLink: "/admin/WebsiteSettings/widgets/currency",
      //     },
      //   ],
      // },
      {
        id: "quiz",
        acl: "quiz",
        title: "Quiz",
        icon: <MdQuiz size={20} />,
        children: [
          {
            id: "view-quiz-workflow",
            acl: "view-quiz-workflow",
            title: "Work Flow",
            icon: <FcQuestions size={40} />,
            navLink: "/admin/quizz/workflow",
          },
          {
            id: "view-quiz-list",
            acl: "view-quiz-list",
            title: "Quiz List",
            icon: <FaThList size={20} />,
            navLink: "/admin/Quiz/quizList",
          },
        ],
      },
      {
        id: "vote",
        acl: "vote",
        title: "Vote",
        icon: <MdQuiz size={20} />,
        children: [
          {
            id: "view-vote-workflow",
            acl: "view-vote-workflow",
            title: "Workflow",
            icon: <FcWorkflow size={40} />,
            navLink: "/admin/vote/workflow",
          },
          {
            id: "view-votes",
            acl: "view-votes",
            title: "Vote List",
            icon: <FaThList size={20} />,
            navLink: "/admin/quizz/quizzlist",
          },
          {
            id: "view-questions",
            acl: "view-questions",
            title: "Question List",
            icon: <MdQuiz size={50} />,
            navLink: "/admin/quizz/questionlist",
          },
          {
            id: "view-answers",
            acl: "view-answers",
            title: "Answers List",
            icon: <RiQuestionnaireLine size={50} />,
            navLink: "/admin/quizz/optionsList",
          },
        ],
      },
      {
        id: "template",
        acl: "template",
        title: "Templates",
        icon: <HiOutlineTemplate size={20} />,
        children: [
          // {
          //   id: "view-templates-backoffice",
          //   acl: "view-templates-backoffice",
          //   title: "Back office",
          //   icon: <FaThList size={20} />,
          //   navLink: "/admin/WebsiteSettings/template/liste",
          // },
          {
            id: "view-templates-frontoffice",
            acl: "view-templates-frontoffice",
            title: "Front office",
            icon: <FaThList size={20} />,
            navLink: "/admin/WebsiteSettings/frontoffice_template",
          },
        ],
      },
    ],
  },
  {
    id: "stream_monitoring",
    acl: "stream_monitoring",
    title: "Stream monitoring",
    icon: <ImStatsBars size={20} />,
    navLink: "/admin/streamMonitor",
    children: [
      {
        id: "view-stream-monitor-table",
        acl: "view-stream-monitor-table",
        title: "Table",
        icon: <BiTable />,
        navLink: "/admin/streamMonitor/table",
      },
      {
        id: "view-stream-monitor-stat",
        acl: "view-stream-monitor-stat",
        title: "Stats",
        icon: <ImStatsBars />,
        navLink: "/admin/streamMonitor/stats",
      },
    ],
  },
];
